export default __webpack_public_path__ + "static/media/team2.6c76650d.jpeg";